import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'selectedFilterName',
})
export class SelectedFilterNamePipe implements PipeTransform {
	transform(id: string, list: any, placeholder: string, filterName?): string {
		if (filterName === 'year' || filterName === 'minPrice' || filterName === 'maxPrice') {
			return id ? list.find((cat) => cat === id) : placeholder;
		}
		return id ? list?.find((cat) => cat?.id === id)?.name : placeholder;
	}
}
